// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import { css } from "styled-components";

currentShippingAddressStyles.gridContainer = {
    gap: 0,
};

currentShippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: baseline;
    `,
};

currentShippingAddressStyles.headingText = { variant: "h4" };

currentShippingAddressStyles.editLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        css: css`
            line-height: 19px;
        `,
    },
    css: css`
        margin-left: 32px;
    `,
};
